<!--
  ATable — Pineapple 톤 테이블
  props:
    columns: [{ key, label, align?, width?, wrap? }]
    rows: 배열 (각 row 는 객체)
    dense: bool
    rowKey: 행의 unique key 추출 함수 또는 키 문자열
  슬롯:
    cell-<key>: 셀 커스텀 렌더 (인자: { row, value, index })
    empty: 데이터 없을 때
-->
<template>
  <div class="a-table-wrap">
    <table class="a-table" :class="{ 'is-dense': dense }">
      <thead>
        <tr>
          <th
            v-for="c in columns"
            :key="c.key"
            :style="{ width: c.width, textAlign: c.align || 'left' }"
          >
            {{ c.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="rows.length === 0">
          <td :colspan="columns.length" class="a-table__empty">
            <slot name="empty">데이터가 없습니다.</slot>
          </td>
        </tr>
        <tr
          v-for="(r, ri) in rows"
          :key="resolveKey(r, ri)"
          :class="{ 'is-alt': ri % 2 === 1 }"
          @click="$emit('row-click', r)"
        >
          <td
            v-for="c in columns"
            :key="c.key"
            :style="{ textAlign: c.align || 'left', whiteSpace: c.wrap ? 'normal' : 'nowrap' }"
          >
            <slot :name="`cell-${c.key}`" :row="r" :value="r[c.key]" :index="ri">{{ r[c.key] }}</slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ATable',
  emits: ['row-click'],
  props: {
    columns: { type: Array, required: true },
    rows: { type: Array, default: () => [] },
    dense: { type: Boolean, default: false },
    rowKey: { type: [Function, String], default: null },
  },
  methods: {
    resolveKey(row, idx) {
      if (typeof this.rowKey === 'function') return this.rowKey(row);
      if (typeof this.rowKey === 'string' && row[this.rowKey] != null) return row[this.rowKey];
      return idx;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.a-table-wrap {
  overflow: auto;
  border-radius: 8px;
  /* 데이터가 적을 때도 기본 테이블 높이 확보 */
  min-height: 240px;
  /* 맨 아래 행의 dropdown menu 가 잘리지 않도록 하단 여백 확보 */
  padding-bottom: 160px;
}

.a-table {
  width: 100%;
  border-collapse: collapse;
  font-family: $p-font-body;

  thead th {
    padding: 10px 14px;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: $p-ink-soft;
    background: $p-bg;
    border-bottom: 1px solid $p-line;
    white-space: nowrap;
  }
  tbody tr {
    border-bottom: 1px solid $p-line-soft;
    &.is-alt { background: $p-panel-alt; }
    &:hover { background: $p-bg; }
  }
  tbody td {
    padding: 14px 14px;
    font-size: 12px;
    color: $p-ink;
    vertical-align: middle;
  }

  &.is-dense {
    thead th { padding: 8px 12px; }
    tbody td { padding: 10px 12px; }
  }

  &__empty {
    padding: 32px !important;
    text-align: center;
    color: $p-ink-soft;
    font-size: 12px;
  }
}
</style>
